import { MessageView, Modal, RealTimeWrapper } from "components";
import { NetworkStatus, useMutation } from "@apollo/client";
import {
  useAppLocation,
  useAppSearch,
  useCurrentUser,
} from "_graphql/cache/auth";
import { useCallback } from "react";

import { SendOfferParticipationMessage } from "_graphql/__generated__/globalTypes";
import { SendOfferParticipationMessageMutationVariables } from "_graphql/mutation/__generated__/SendOfferParticipationMessageMutation";
import config from "config";
import { sendOfferParticipationMessage } from "_graphql/visal/mutations/publish-offer";
import toast from "react-hot-toast";
import { useFormik } from "formik";
import { useParticipationThread } from "hooks/data/use-participation-thread";

export default function OfferTransactionThreadContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}) {
  const searchParams = useAppSearch();
  const { params } = useAppLocation();
  const { employee } = useCurrentUser();
  const participantId = searchParams?.id || "";
  const [sendMessage] = useMutation<
    SendOfferParticipationMessage,
    SendOfferParticipationMessageMutationVariables
  >(sendOfferParticipationMessage, {
    refetchQueries: ["OfferTransactionThread"],
  });
  const {
    thread,
    refetch: refetchThread,
    networkStatus,
  } = useParticipationThread({
    input: {
      offer_published_participant_id: participantId,
    },
  });
  // const [fetchMessages, { loading: fetchMessagesLoading }] = useQuery(
  //   offerTransactionThread,
  //   {
  //     client: placeItClient,
  //     onCompleted: (data) => {
  //       if (data?.offerTransactionThread) {
  //         setMessages(data.offerTransactionThread);
  //       }
  //     },
  //     onError: (error) => {
  //       toast.error("Failed to load transaction thread");
  //     },
  //   }
  // );

  // useEffect(() => {
  //   if (participantId && open) {
  //     setLoading(true);
  //     fetchMessages({
  //       variables: {
  //         input: {
  //           offer_published_participant_id: participantId,
  //         },
  //       },
  //     }).finally(() => setLoading(false));
  //   }
  // }, [participantId, open, fetchMessages]);

  const handleSubmit = useCallback(
    async (values: { message: string }) => {
      try {
        sendMessage({
          variables: {
            input: {
              firstname: employee?.employee_first_name || "",
              lastname: employee?.employee_last_name || "",
              message: values.message,
              offer_published_participant: participantId,
              offer_published_id: params?.offer || "",
            },
          },
        })
          .then((res) => {
            toast.success("Message sent successfully");
            form.resetForm();
          })
          .catch((err) => {
            toast.error("Failed to send message");
          });
      } catch (error) {
        toast.error("Failed to send message");
      }
    },
    [employee?.employee_first_name, employee?.employee_last_name]
  );

  const form = useFormik({
    initialValues: {
      message: "",
    },
    onSubmit: handleSubmit,
  });

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={[NetworkStatus.loading].includes(networkStatus)}
      size="5xl"
      title="Transaction Thread"
      description="Communication thread with Reinsurance Underwriters on KAVAr"
      // renderActions={renderActions}
      hideActions
    >
      <div className="bg-blue-100 rounded-none mb-4 p-2">
        <p className="text-xs text-blue-800 px-4 pt-2">
          Secure Transactional Threads enable realtime, encrypted communication
          between communicating parties, ensuring confidential negotiations.
        </p>
        <p className="text-xs text-blue-800 px-4 pt-2">
          When both parties are online, they can collaborate instantly—sharing
          documents, discussing terms, and closing deals faster. Key benefits
          include end-to-end security, live interaction, and streamlined
          workflows for time-sensitive transactions.
        </p>
      </div>
      <RealTimeWrapper
        channel={config.pusher.channels.kava}
        events={[
          "reinsurer.interest",
          "reinsurer.remove_interest",
          "reinsurer.thread_notification",
        ]}
        callBack={() => refetchThread()}
      >
        <MessageView
          offers={thread.map((msg) => ({
            ...msg,
            __typename: "OfferMessageContent", // TODO: This should probably be changed.
            // uuid: msg.uuid || `temp-${Date.now()}-${Math.random()}`,
            // sender_name: msg.sender_name || "Unknown",
            // state: "INTERNAL",
            timestamp: msg.timeStamp,
            message: msg.message,
          }))}
          form={form}
        />
      </RealTimeWrapper>
    </Modal>
  );
}
